import { type IConfig } from '@unleash/proxy-client-react';

export default function getUnleashConfig(): IConfig {
  return {
    url: `${window.location.origin}/features/proxy`,
    clientKey: 'd1a1a1cc-f56f-4537-b770-c94f3772ce52',
    refreshInterval: 15,
    appName: 'bank-onboarding-web',
  };
}
